import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared/shared.module';
import { DatePipe } from '@angular/common';
import { LimiteHistoricoPesquisaComponent } from '../limite-historico/limite-historico-pesquisa/limite-historico-pesquisa.component';
import { LimiteHistoricoListagemComponent } from '../limite-historico/limite-historico-listagem/limite-historico-listagem.component';
import { LimiteHistoricoRoutingModule } from './limite-historico-routing.module';

@NgModule({
  imports: [
    SharedModule,
    LimiteHistoricoRoutingModule
  ],
  declarations: [
    LimiteHistoricoPesquisaComponent,
    LimiteHistoricoListagemComponent,
  ],
  providers: [
    DatePipe
  ]
})
export class LimiteHistoricoModule { }
